import axios from "axios";
import Cookies from "js-cookie";
import { rsaEncryption, aesEncryption } from "./security";
import { getReference } from "../utils/utilityFunctions";
import * as types from "../redux/actions/types/app.types";
import { salesUrls, urls } from "./url";

// axios.defaults.headers.common = {
//     "X-Requested-With": "XMLHttpRequest",
// };

// axios.defaults.baseURL = `${process.env.REACT_APP_LIVE_URL}`;
// axios.defaults.headers.post["Content-Type"] = "application/json";

const encryptData = (key, payload) => {
    return aesEncryption(payload, key);
};

export const interceptor = (status, dispatch) => {
    // if (status === 400) {
    //     dispatch({ type: types.SHOW_ERROR_MODAL });
    // } else if (status === 401) {
    //     dispatch({ type: types.SHOW_EXPIRED_MODAL });
    // } else if (status === 404) {
    //     dispatch({ type: types.SHOW_ERROR_MODAL });
    // } else if (status === 409) {
    //     dispatch({ type: types.SHOW_EXPIRED_MODAL });
    // } else if (status === 403) {
    //     dispatch({ type: types.SHOW_EXPIRED_MODAL });
    // } else if (status === 504) {
    //     dispatch({ type: types.SHOW_ERROR_MODAL });
    // } else if (status === 500 || status === 100 || status === 502) {
    //     dispatch({ type: types.SHOW_RETRY_MODAL });
    // } else {
    //     dispatch({ type: types.SHOW_ERROR_MODAL });
    // }
};

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

const handleTokenRefresh = async (dispatch, originalConfig) => {
    const getSessionKudaAppToken = sessionStorage.getItem("kudaAppToken");
    const getkudaAppRefreshToken = Cookies.get("kudaAppRefreshToken");
    const fromSalesMode = Cookies.get("fromSalesMode");

    const token = { RefreshToken: getkudaAppRefreshToken };
    const payload = { isTokenExchange: false };

    if (isRefreshing) {
        return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
        })
            .then((token) => {
                originalConfig.headers.Authorization = `Bearer ${token}`;
                return axios(originalConfig);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    isRefreshing = true;

    try {
        const response =
            fromSalesMode === "true"
                ? await postCall(salesUrls.refreshSalesToken, payload, "", token)
                : await postCall(urls.refreshToken, payload, "", token);
        if (!response?.data?.isSuccessful) {
            originalConfig.__retryCount++;
            if (originalConfig.__retryCount >= 1) {
                dispatch({
                    type: types.SHOW_EXPIRED_MODAL,
                    payload: response?.data?.message,
                });
                processQueue(response?.data?.message, null);
                return Promise.reject(response?.data?.message);
            }
            return axios(originalConfig); // Retry the request
        }

        const {
            accessToken: AppToken,
            refreshToken,
            tokenExpiryInMinutes: expiresIn,
        } = response.data.data;
        Cookies.set("kudaAppRefreshToken", refreshToken, { secure: true, path: "/" });
        Cookies.set("expiresIn", expiresIn, { secure: true, path: "/" });

        if (getSessionKudaAppToken) {
            sessionStorage.setItem("kudaAppToken", AppToken);
        } else {
            Cookies.set("kudaAppToken", AppToken, { secure: true, path: "/" });
        }

        originalConfig.headers.Authorization = `Bearer ${AppToken}`;
        axios.defaults.headers.common["Authorization"] = `Bearer ${AppToken}`;
        processQueue(null, AppToken);
        isRefreshing = false;
        return axios(originalConfig);
    } catch (error) {
        processQueue(error, null);
        isRefreshing = false;
        return Promise.reject(error);
    }
};

const handleNetworkError = () => {
    const errorMessage = {
        response: {
            data: {
                message: "Network Error. Please check if you are connected to the internet.",
            },
        },
    };
    return Promise.reject(errorMessage);
};

const handleError = (error, dispatch) => {
    if (error?.response) {
        switch (error.response.status) {
            case 401:
            case 403:
                const originalConfig = error.config;
                originalConfig.__retryCount = originalConfig.__retryCount || 0;

                return handleTokenRefresh(dispatch, originalConfig);
            case 504:
                const errorMessage = {
                    response: {
                        data: {
                            message: "An error occurred. Please reload the browser and try again.",
                        },
                    },
                };
                return Promise.reject(errorMessage);
            default:
                return Promise.reject(error);
        }
    }

    if (error.message === "Network Error") {
        return handleNetworkError();
    }

    return Promise.reject(error);
};

export const intercept = (store) => {
    const { dispatch } = store;

    axios.interceptors.response.use(
        (response) => Promise.resolve(response),
        (error) => handleError(error, dispatch),
    );
};
export function dispatchAppropirateResponse(response, successObj, failureObj, dispatch) {
    if (response.data.isSuccessful === true) {
        dispatch(successObj);
        return true;
    } else if (response.data.isSuccessful === false) {
        dispatch(failureObj);
        return false;
    } else if (typeof response === "undefined") {
        dispatch(failureObj);
        return false;
    } else if (response === 401) {
        interceptor(response, dispatch);
    } else if (response === 400) {
        interceptor(response, dispatch);
    } else if (response === 404) {
        interceptor(response, dispatch);
    } else if (response === 403) {
        interceptor(response, dispatch);
    } else if (response === 500) {
        interceptor(response, dispatch);
    } else if (response === 504) {
        interceptor(response, dispatch);
    } else {
        dispatch(failureObj);
        return false;
    }
}

export const postFormCall = async (url, { data, file }, headers, option) => {
    document.body.classList.add("network-active");
    const sessionKudaAppToken = sessionStorage.getItem("kudaAppToken");
    const cookiesKudaAppToken = Cookies.get("kudaAppToken");
    const kudaAppToken = sessionKudaAppToken ? sessionKudaAppToken : cookiesKudaAppToken;
    const authorizationField = "Bearer " + kudaAppToken;

    const bodyFormData = new FormData();
    if (process.env.REACT_APP_ENCRYPTED === "true") {
        const password = getReference();
        const rsaKey = rsaEncryption(password);

        const encryptedData = {
            key: rsaKey,
            data: aesEncryption(JSON.stringify(data), password),
        };

        headers = Object.assign({ "Content-Type": "multipart/form-data", "encryptionKey": rsaKey });

        bodyFormData.append("model", JSON.stringify(encryptedData));
        if (!option?.noFile) bodyFormData.append("file", file);
    } else {
        headers = Object.assign({ "Content-Type": "multipart/form-data" });
        if (!option?.noFile) bodyFormData.append("file", file);
        bodyFormData.append("model", `${JSON.stringify(data)}`);
    }

    return axios({
        method: "post",
        url: url,
        data: bodyFormData,
        headers: {
            ...headers,
            "Authorization": authorizationField,
        },
    }).catch(function (error) {
        if (!error.response) {
            // network error
        } else {
            const { status } = error.response;
            return status;
        }
    });
};

export const postFormCallBizReg = async (url, { data, files }, headers, option) => {
    document.body.classList.add("network-active");
    const sessionKudaAppToken = sessionStorage.getItem("kudaAppToken");
    const cookiesKudaAppToken = Cookies.get("kudaAppToken");
    const kudaAppToken = sessionKudaAppToken ? sessionKudaAppToken : cookiesKudaAppToken;
    const authorizationField = "Bearer " + kudaAppToken;

    const bodyFormData = new FormData();
    if (process.env.REACT_APP_ENCRYPTED === "true") {
        const password = getReference();
        const rsaKey = rsaEncryption(password);

        const encryptedData = {
            key: rsaKey,
            data: aesEncryption(JSON.stringify(data), password),
        };

        headers = Object.assign({ "Content-Type": "multipart/form-data", "encryptionKey": rsaKey });

        bodyFormData.append("data", JSON.stringify(encryptedData));

        for (let file of files) {
            bodyFormData.append(file.name, file.file);
        }
    } else {
        headers = Object.assign({ "Content-Type": "multipart/form-data" });
    }
    return axios({
        method: "post",
        url: url,
        data: bodyFormData,
        headers: {
            ...headers,
            "Authorization": authorizationField,
        },
    }).catch(function (error) {
        if (!error.response) {
            // network error
        } else {
            const { status } = error.response;
            return status;
        }
    });
};

const preparePostCall = async (url, data, params, headers) => {
    document.body.classList.add("network-active");

    let finalData;
    const sessionKudaAppToken = sessionStorage.getItem("kudaAppToken");
    const cookiesKudaAppToken = Cookies.get("kudaAppToken");
    const kudaAppToken = sessionKudaAppToken ? sessionKudaAppToken : cookiesKudaAppToken;
    const authorizationField = "Bearer " + kudaAppToken;

    if (process.env.REACT_APP_ENCRYPTED === "true") {
        const password = getReference();
        const rsaKey = rsaEncryption(password);
        const encryptedData = await encryptData(password, JSON.stringify(data));

        finalData = {
            key: rsaKey,
            data: encryptedData,
        };
        const keyValue = { encryptionKey: rsaKey, ...headers };
        headers = Object.assign(keyValue);
    } else {
        finalData = data;
        headers = Object.assign("");
    }

    return axios({
        method: "post",
        url: url,
        data: finalData,
        headers: {
            Authorization: authorizationField,
            ...headers,
        },
        params: params,
    });
};

export const postCall = async (url, data, params, headers) => {
    try {
        return await preparePostCall(url, data, params, headers);
    } catch (error) {
        if (!error.response) {
            // network error
            interceptor(100);
        } else {
            const { status } = error.response;
            return status;
        }
    }
};

export const postCallWithoutCatch = async (url, data, params, headers) => {
    return await preparePostCall(url, data, params, headers);
};

export const getCall = async (url, params, headers) => {
    const sessionKudaAppToken = sessionStorage.getItem("kudaAppToken");
    const cookiesKudaAppToken = Cookies.get("kudaAppToken");
    const kudaAppToken = sessionKudaAppToken ? sessionKudaAppToken : cookiesKudaAppToken;
    const authorizationField = "Bearer " + kudaAppToken;
    return axios({
        method: "get",
        url: url,
        params: params,
        headers: {
            ...headers,
            "Authorization": authorizationField,
        },
    }).catch(function (error) {
        if (!error.response) {
            // network error
        } else {
            const { status } = error.response;
            return status;
        }
    });
};

export const deleteCall = async (url, params, headers) => {
    const sessionKudaAppToken = sessionStorage.getItem("kudaAppToken");
    const cookiesKudaAppToken = Cookies.get("kudaAppToken");
    const kudaAppToken = sessionKudaAppToken ? sessionKudaAppToken : cookiesKudaAppToken;
    const authorizationField = "Bearer " + kudaAppToken;
    return axios({
        method: "delete",
        url: url,
        params: params,
        headers: {
            ...headers,
            "Authorization": authorizationField,
        },
    }).catch(function (error) {
        if (!error.response) {
            // network error
        } else {
            const { status } = error.response;
            return status;
        }
    });
};
